<div class="frame">
  <div class="icon">
    <img class="image" [src]="displayLogo(provider.logo)" />
  </div>
  <div class="title">
    <div class="heading">{{ provider.name }}</div>
    <div class="status">Platform</div>
  </div>
</div>
<div class="description">
  <p class="body">
    {{ provider.description }}
  </p>
</div>
<div class="outlined-large" (click)="onClick()">
  <div class="buttons-medium">CONNECT</div>
</div>
